import { NodeApi } from 'platejs'

import unsetPropertyInEditor from '~publish/legacy/ai/helpers/unsetPropertyInEditor'
import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import { capitalizeTextAsSelection } from '~publish/legacy/editor/helpers/capitalizeTextAsSelection'
import { createParagraphsFromText } from '~publish/legacy/editor/nodes'

import { getSelection } from './getSelection'

export async function addGeneratedContent({
  editor,
  content,
}: {
  editor: BufferEditor
  content: string
}): Promise<void> {
  /* We use two properties to control the animation of the generated content and keep information
  about the nodes generated by AI Assistant */
  const paragraphs = createParagraphsFromText(content, {
    generatedByAI: true,
    shouldAnimateGeneration: true,
  })
  if (paragraphs.length === 0) return

  /* AI can Replace or Insert text. If it's a replacement, we need to insert the content inline,
   * but using insertNodes all the nodes will be considered inline, so we need to extract the first
   * node, adding as text to the editor, and then insert the rest of the nodes.
   */
  const selectedText = getSelection({ editor })
  const isAReplacement = !!selectedText
  const isEditorEmpty =
    editor.children.length === 1 && NodeApi.string(editor).trim() === ''

  if (isAReplacement || isEditorEmpty) {
    /* we extract the first paragraph and insert it as text along with t current text */
    const firstParagraph = paragraphs.shift()

    let nodeToInsert = firstParagraph
    if (selectedText && nodeToInsert) {
      nodeToInsert = capitalizeTextAsSelection(nodeToInsert, selectedText)
    }

    if (nodeToInsert) {
      editor.tf.insertNodes(nodeToInsert.children)
    }
  }

  /* The rest of the paragpahs or all of them if it's not a replacement
  are inserted as nodes type p */
  if (paragraphs.length > 0) {
    editor.tf.insertNodes(paragraphs, {
      at: selectedText ? undefined : [editor.children.length],
    })
  }

  /* Once the animation has played, clear `shouldAnimateGeneration` so it doesn't
  linger on the nodes or re-trigger when the user keeps editing. We also drop the
  now-unused `generatedByAI` marker in the same pass to keep the generated nodes
  tidy. We go through Slate transforms (unsetNodes) rather than mutating the nodes
  directly because Slate deep-freezes its node tree. */
  setTimeout(() => {
    unsetPropertyInEditor(editor, ['shouldAnimateGeneration', 'generatedByAI'])
  }, 1000)
}
